import { toAbsoluteApiUrl } from '../../../../../helpers/http-client';

export const ADDITIONAL_FIELD_TYPES = {
    SHORT_TEXT: 'SHORT_TEXT',
    LONG_TEXT: 'LONG_TEXT',
    NUMBER: 'NUMBER',
    LIST: 'LIST',
    CHECKBOX: 'CHECKBOX',
};

export const parseCustomFieldValue = (field, rawValue) => {
    const fieldType = field?.type;

    if (fieldType === ADDITIONAL_FIELD_TYPES.NUMBER) {
        if (rawValue === '' || rawValue === null || rawValue === undefined) {
            return undefined;
        }

        const parsed = Number(rawValue);
        return Number.isNaN(parsed) ? undefined : parsed;
    }

    if (fieldType === ADDITIONAL_FIELD_TYPES.CHECKBOX) {
        return Boolean(rawValue);
    }

    const normalized = String(rawValue ?? '').trim();
    return normalized || undefined;
};

export const formatDateTime = (value) => {
    if (!value) return '-';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '-';
    return parsed.toLocaleString('es-MX');
};

export const renderCustomFieldValue = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : '-';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
};

export const getPlainTextFromHtml = (html = '') => {
    return String(html || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

export const fileMatchesReference = (file, { refType, refId, refField }) => {
    const refs = Array.isArray(file?.references) ? file.references : [];
    return refs.some((ref) => {
        return String(ref?.refType || '').toUpperCase() === String(refType || '').toUpperCase()
            && String(ref?.refId || '') === String(refId || '')
            && String(ref?.refField || '').toLowerCase() === String(refField || '').toLowerCase()
            && Boolean(ref?.active);
    });
};

export const fileHasTicketReferenceWithoutField = (file, ticketId) => {
    const refs = Array.isArray(file?.references) ? file.references : [];
    return refs.some((ref) => {
        return String(ref?.refType || '').toUpperCase() === 'TICKET'
            && String(ref?.refId || '') === String(ticketId || '')
            && !String(ref?.refField || '').trim()
            && Boolean(ref?.active);
    });
};

export const ticketTypeIconMap = {
    INCIDENT: 'bi bi-exclamation-octagon',
    REQUEST: 'bi bi-life-preserver',
    PROBLEM: 'bi bi-bug',
    CHANGE: 'bi bi-arrow-repeat',
    TASK: 'bi bi-list-task',
};

export const ticketTypeBadgeMap = {
    INCIDENT: 'bg-soft-danger text-danger',
    REQUEST: 'bg-soft-info text-info',
    PROBLEM: 'bg-soft-warning text-warning',
    CHANGE: 'bg-soft-primary text-primary',
    TASK: 'bg-soft-secondary text-secondary',
};

export const normalizeTag = (value = '') => {
    return String(value || '').trim().replace(/\s+/g, ' ');
};

export const getFollowAuthorAvatar = (author) => {
    const avatar = String(author?.photoUrl || author?.avatar || '').trim();
    return toAbsoluteApiUrl(avatar);
};

export const parseTags = (value = '') => {
    const items = String(value || '')
        .split(',')
        .map((tag) => normalizeTag(tag))
        .filter(Boolean);

    return Array.from(new Set(items));
};
